import React from 'react';
import Radium from 'radium';

import styles from './styles';
import ChatHistoryHeaderInfo from '../ChatHistoryHeaderInfo';

export const ChatHistoryHeader = ({ onClose }) => {
  return (
    <div key="wrapper" style={styles.wrapper} className="kustomer-app-header">
      <ChatHistoryHeaderInfo />
      <div
        style={styles.close.wrapper}
        className="iconButton closeButton kustomer-app-header-close-button"
        onClick={onClose}
      >
        <div style={styles.close.icon} />
      </div>
    </div>
  );
};

ChatHistoryHeader.propTypes = {
  onClose: React.PropTypes.func,
};

ChatHistoryHeader.defaultProps = {
  onClose: () => {},
};

export default Radium(ChatHistoryHeader);
